import { defineStyle as t, defineStyleConfig as a } from "@chakra-ui/styled-system";
const l = t({
  textStyle: "bodyBoldSmall",
  px: 1,
  borderRadius: "base"
}), r = t((o) => {
  const { colorScheme: e, theme: n } = o;
  return {
    bg: `${e}.100`,
    color: `${e}.800`
  };
}), s = {
  subtle: r
}, b = a({
  baseStyle: l,
  variants: s,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
});
export {
  b as default
};
